export const ResultPaymentStyle:React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
}

export const ResultStyle:React.CSSProperties = {
  display: "flex",
  width: "95%",
  flexDirection: "column",
  gap: "32px",  
}

export const ResultTitleStyle:React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "32px",
  alignSelf: "stretch"
}